import { type GetMembersQueryParams } from '@gonfalon/openapi/operations/getMembers';

import { createQueryHook } from '../internal/createQueryHook';
import { getMembersQuery } from '../queries/members';

/**
 * @deprecated Use `getMembersQuery()` with `useQuery` directly.
 */
export const useMembers = createQueryHook(({ params }: { params?: GetMembersQueryParams }) =>
  getMembersQuery({ query: params }),
);
